import { render, staticRenderFns } from "./RequisitosPassword.vue?vue&type=template&id=ddcc699e&scoped=true"
import script from "./RequisitosPassword.vue?vue&type=script&lang=js"
export * from "./RequisitosPassword.vue?vue&type=script&lang=js"
import style0 from "./RequisitosPassword.vue?vue&type=style&index=0&id=ddcc699e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc699e",
  null
  
)

export default component.exports